
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Image from '../../ui/Image';
import DictSelect from '../../ui/DictSelect';

const fields = [{
    "text": "所属系统",
    "field": "type",
    select: true,
    "category": "CAROUSEL_TYPE",
    rules: [
        { required: true, message: '所属系统不能为空!' },
    ]
}, {
    "text": "描述信息",
    "field": "des",
    rules: [
        { required: true, message: '描述信息不能为空!' },
        { max: 128, message: '描述信息不能超过128个字符！' },
    ]
}, {
    "text": "显示顺序",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '显示顺序不能为空!' },
    ]
}, {
    "text": "展示内容",
    "field": "content",
    textarea: true
}, {
    "text": "图片",
    "field": "image",
    image: true
}];


class CarouselEditForm extends Component {

    state = {
        imageUrl: null,
        image: null
    }


    componentDidMount() {
        this.props.onRef(this);
    }

    initImage = (editData) => {
        let image = editData.image;
        if (image != null && image !== "") {
            image = "data:image/jpeg;base64," + image.replace(/\r\n/g, "");
        }
        this.setState({ image: image, imageUrl: editData.imageUrl });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            let imageUrl = this.state.imageUrl;
            if (imageUrl != null && imageUrl !== "") {
                values["image"] = imageUrl;
            } else {
                values["image"] = this.state.image;
            }
            if (values["image"] == null || values["image"] === "") {
                messager.notify("图片不能为空！");
                return;
            }
            http.post({
                url: '/carousel/saveCarousel',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    handleUploadImage = (field, { base64 }) => {
        this.setState({ "image": base64, "imageUrl": null });
    }
    handleRemoveImage = (field, index) => {
        this.setState({ "image": null, "imageUrl": null });
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {item.image ?
                        <Image
                            onChange={this.handleUploadImage.bind(this, item.field)}
                            onRemove={this.handleRemoveImage.bind(this, item.field)}
                            file={this.state.image}
                            text={item.text}
                            url={this.state.imageUrl}
                        />
                        : getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field] != null && item.select ? "" + editData[item.field] : editData[item.field],
                        })(
                            item.select ? <DictSelect category={item.category} />
                                : item.number ? <InputNumber precision={0} min={1} style={{ width: '100%' }} />
                                    : item.textarea ? <Input.TextArea />
                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={500}
                visible={visible}
                title="轮盘信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ image: null, imageUrl: null }); this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const CarouselEdit = Form.create()(CarouselEditForm);

export default CarouselEdit;